/**
 * German Translations
 */

export const de = {
  // Common
  continue: "Weiter",
  back: "← Zurück",
  next: "Weiter",
  previous: "Zurück",
  submit: "Absenden",
  cancel: "Abbrechen",
  save: "Speichern",
  edit: "Bearbeiten",
  delete: "Löschen",
  close: "Schließen",
  loading: "Wird geladen...",
  error: "Fehler",
  success: "Erfolg",
  warning: "Warnung",
  info: "Information",
  required: "Erforderlich",
  optional: "Optional",
  
  // Property Valuation Result Storytelling Widget
  // Introduction Section
  propertyStoryIntro: "Scrollen Sie nach unten und entdecken Sie Informationen über Ihre Immobilie",
  
  // Chapter 1: The Property
  theProperty: "Die Immobilie",
  propertyDescription: "Jede Immobilie hat ihre Geschichte. Diese {living_area}m² Wohnung in {city} besteht seit {year}.",
  propertyProfile: "Immobilienprofil",
  propertyType: "Immobilientyp",
  rooms: "Zimmer",
  historicalContext: "Historischer Kontext",
  yearBuilt: "Baujahr",
  currentCondition: "Aktueller Zustand",
  parking: "Parkplatz",
  
  // Chapter 2: The Location
  theLocation: "Die Lage",
  locationDescription: "Die Lage gilt oft als der wichtigste Faktor bei der Immobilienbewertung. Lassen Sie uns erkunden, was die Lage dieser Immobilie besonders macht.",
  landInformation: "Grundstücksinformationen",
  landType: "Grundstückstyp",
  egridNumber: "EGRID-Nummer",
  zoning: "Zoneneinteilung",
  inForceSince: "In Kraft seit",
  
  // Map Controls
  streetView: "Straßenansicht",
  satelliteView: "Satellitenansicht",
  priceHeatmap: "Preisheatmap",
  zoningPlan: "Zonenplan",
  mapNotAvailable: "Interaktive Karte nicht verfügbar",
  mapLoadError: "Fehler beim Laden der Karte",
  
  // Chapter 3: The Market
  theMarket: "Der Markt",
  marketDescription: "Das Verständnis des breiteren Marktkontexts hilft, den Wert Ihrer Immobilie in die richtige Perspektive zu rücken.",
  pricePerM2Comparison: "Preis pro m² Vergleich",
  medianPriceComparison: "Vergleich der Medianpreise",
  areaVsRegion: "Ihr Gebiet vs. Region Genf",
  yourArea: "Ihr Gebiet",
  genevaRegion: "Region Genf",
  localMarketTrends: "Lokale Markttrends",
  averagePrice: "Durchschnittspreis Q1 2025",
  transactions: "Transaktionen Q1 2025",
  priceTrend: "Preistrend (2023-2025)",
  regionalContext: "Regionaler Kontext",
  regionAverage: "Durchschnitt Region Genf",
  regionalTransactions: "Regionale Transaktionen",
  regionalTrend: "Regionaler Trend",
  
  // Chapter 4: The Neighborhood
  theNeighborhood: "Die Nachbarschaft",
  neighborhoodDescription: "Der Wert einer Immobilie wird stark von ihrer Umgebung beeinflusst. Von kulturellen Angeboten bis hin zu alltäglichen Notwendigkeiten - entdecken wir, was diesen Ort besonders macht.",
  nearbyPoi: "Nahe gelegene Sehenswürdigkeiten",
  artCulture: "Kunst & Kultur",
  cafe: "Café",
  financial: "Finanzen",
  publicUtility: "Öffentliche Einrichtung",
  environmentalFactors: "Umweltfaktoren",
  roadNoiseDay: "Straßenlärm (Tag)",
  roadNoiseNight: "Straßenlärm (Nacht)",
  railwayNoiseDay: "Schienenlärm (Tag)",
  railwayNoiseNight: "Schienenlärm (Nacht)",
  veryHigh: "Sehr Hoch",
  high: "Hoch",
  moderate: "Mittel",
  low: "Niedrig",
  veryLow: "Sehr Niedrig",
  neighborhoodScores: "Bewertungen der Nachbarschaft",
  neighborhoodQualityAssessment: "Bewertung der Nachbarschaftsqualität",
  neighborhoodQuality: "Nachbarschaftsqualität",
  yourProperty: "Ihre Immobilie",
  genevaAverage: "Durchschnitt Genf",
  shopping: "Einkaufen",
  grocery: "Lebensmittel",
  cultureEntertainment: "Kultur und Unterhaltung",
  diningDrinking: "Essen und Trinken",
  education: "Bildung",
  wellness: "Wellness",
  healthcare: "Gesundheitswesen",
  transport: "Verkehr",
  basicAmenities: "Grundlegende Annehmlichkeiten",
  outstandingCategories: "Herausragende Kategorien",
  cultureEntertainmentDesc: "10/10 - Zugang zu Museen, Theatern und kulturellen Veranstaltungsorten",
  diningDrinkingDesc: "10/10 - Hochwertige Restaurants und Cafés in der Nähe",
  educationDesc: "10/10 - Ausgezeichnete Schulen und Bildungseinrichtungen",
  areasConsideration: "Bereiche zur Berücksichtigung",
  transportDesc: "7/10 - Gute, aber begrenzte Transportmöglichkeiten",
  healthcareDesc: "6/10 - Einige Gesundheitseinrichtungen in der Nähe, aber begrenzte Fachgebiete",
  
  // Chapter 5: The Value
  theValue: "Der Wert",
  valueDescription: "Nachdem wir die Immobilie, ihre Lage, den Marktkontext und die Qualität der Nachbarschaft erkundet haben, können wir eine umfassende Bewertung basierend auf all diesen Faktoren präsentieren.",
  goodConfidence: "Gute Zuverlässigkeit",
  mediumConfidence: "Mittlere Zuverlässigkeit",
  lowConfidence: "Geringe Zuverlässigkeit",
  priceAnalysis: "Preisanalyse",
  pricePerM2: "Preisspanne pro m²",
  
  // Property Valuation Result MapDashboard Widget
  price: "Preis",
  zoning: "Zonierung",
  noise: "Lärm",
  pricePerSquareMeter: "Preis pro m²",
  estimatedValueRange: "Geschätzter Wertbereich",
  confidence: "Vertrauen",
  fullReport: "Vollständiger Bericht",
  share: "Teilen",
  propertyDetails: "Immobiliendetails",
  propertyInformation: "Immobilieninformation",
  livingArea: "Wohnfläche",
  yearBuilt: "Baujahr",
  marketAnalysis: "Marktanalyse",
  avgPricePerSquareMeter: "Durchschn. Preis/m²",
  annualTrend: "Jährlicher Trend",
  energyEnvironment: "Energie & Umwelt",
  energyRating: "Energieklasse",
  noiseLevel: "Lärmbelastung",
  pointsOfInterest: "Interessenpunkte",
  low: "Niedrig",
  medium: "Mittel",
  high: "Hoch",
  
  // Property Valuation Widget
  // Step 1: Address Input
  whereProperty: "Wo befindet sich Ihre Immobilie?",
  enterAddress: "Geben Sie Ihre Adresse ein",
  
  // Step 2: Location with Map
  isThisProperty: "Ist dies Ihre Immobilie?",
  confirmAddress: "Adresse bestätigen",
  thisIsMyProperty: "Dies ist meine Immobilie",
  confirmLocation: "Standort bestätigen",
  
  // Step 3b: Apartment Selection
  selectApartment: "Wählen Sie Ihre Wohnung",
  customApartment: "Individuelle Wohnung",
  enterCustomDetails: "Geben Sie Ihre Wohnungsdetails manuell ein",
  floor: "Stockwerk",
  
  // Step 4: Property Details
  tellAboutProperty: "Erzählen Sie uns von Ihrer Immobilie",
  bedrooms: "Anzahl Zimmer",
  bathrooms: "Anzahl Badezimmer",
  livingArea: "Wohnfläche (m²)",
  landArea: "Grundstücksfläche (m²)",
  exactBedrooms: "Genaue Anzahl Zimmer",
  exactBathrooms: "Genaue Anzahl Badezimmer",
  condition: "Zustand",
  needsRenovation: "Renovierungsbedürftig",
  wellMaintained: "Gut gepflegt",
  newOrRenovated: "Neu oder kürzlich renoviert",
  constructionYear: "Baujahr",
  regblPrefillData: "Wir füllen die Daten vor, indem wir das Eidg. Gebäude- und Wohnungsregister (GWR), wenn wir können. Bitte überprüfen Sie die Details.",
  
  // Step 5: Valuation Purpose
  valuationPurpose: "Wofür benötigen Sie die Bewertung?",
  sellingSoon: "Bald verkaufen",
  justCurious: "Nur neugierig",
  buyingSoon: "Bald kaufen",
  refinancing: "Refinanzierung",
  whenSelling: "Wann planen Sie den Verkauf?",
  asap: "So schnell wie möglich",
  within3months: "Innerhalb von 3 Monaten",
  threeToSixMonths: "3-6 Monate",
  sixToTwelveMonths: "6-12 Monate",
  justExploring: "Ich erkundige mich nur",
  whatPrice: "Wie schätzen Sie den Immobilienwert?",
  helpUnderstand: "Das hilft uns, Ihre Erwartungen zu verstehen, beeinflusst jedoch nicht die Bewertung.",
  
  // Step 6: Loading/Processing
  processingData: "Verarbeitung Ihrer Immobiliendaten",
  pleaseWait: "Bitte warten Sie, während unser Modell Ihre Immobilie analysiert...",
  analyzingLocation: "Analyse der Standortdaten",
  findingComparables: "Suche nach vergleichbaren Immobilien",
  calculatingTrends: "Berechnung von Markttrends",
  finalizingValuation: "Fertigstellung der Bewertung",
  
  // Step 7: Contact Information
  valuationReady: "Ihre Bewertung ist fertig!",
  provideContact: "Bitte hinterlassen Sie Ihre Kontaktdaten, um Ihre Immobilienwertanalyse zu erhalten.",
  fullName: "Vollständiger Name",
  yourName: "Ihr Name",
  emailAddress: "E-Mail-Adresse",
  yourEmail: "Ihre E-Mail",
  phoneNumber: "Telefonnummer",
  yourPhone: "Ihre Telefonnummer",
  title: "Anrede",
  mr: "Herr",
  mrs: "Frau",
  ms: "Fräulein",
  firstName: "Vorname",
  lastName: "Nachname",
  comment: "Zusätzliche Kommentare (optional)",
  yourComment: "Erzählen Sie uns mehr über Ihre Bedürfnisse",
  agreeReceive: "Ich stimme zu, dass ich bei Fragen oder für weitere Informationen kontaktiert werden kann und bestätige, dass ich die",
  privacyPolicy: "Datenschutzbestimmungen einsehen konnte",
  getValuation: "Meine Bewertung erhalten",
  
  // Step 8: SMS Verification
  verifyPhone: "Bestätigen Sie Ihre Telefonnummer",
  sentCode: "Wir haben einen 4-stelligen Code an Ihr Telefon gesendet. Bitte geben Sie ihn unten ein, um Ihre Telefonnummer zu bestätigen.",
  didntReceive: "Keinen Code erhalten?",
  resendCode: "Code erneut senden",
  verifyView: "Bestätigen & Ergebnisse anzeigen",
  
  // Step 8b: SMS code verification
  processingSmsCode: "Verarbeitung des SMS-Codes",
  pleaseWaitSmsCode: "Bitte warten Sie, während wir Ihre Telefonnummer überprüfen...",
  
  // Step 9: Appraisal Result
  propertyValuation: "Ihre Immobilienbewertung",
  estimatedRange: "Geschätzter Bereich:",
  confidence: "Bewertungssicherheit:",
  medium: "Mittel",
  valuationBased: "Diese Bewertung basiert auf aktuellen Vergleichsverkäufen, Markttrends und den von Ihnen angegebenen Objektdetails.",
  downloadReport: "Bericht anzeigen",
  contactAgent: "Makler kontaktieren",
  startNew: "Eine neue Bewertung starten",
  
  // Validation messages
  invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein",
  requiredField: "Dieses Feld ist erforderlich",
  minCharacters: "Bitte geben Sie mindestens {{min}} Zeichen ein",
  maxCharacters: "Bitte geben Sie höchstens {{max}} Zeichen ein",
  minValue: "Bitte geben Sie einen Wert größer oder gleich {{min}} ein",
  maxValue: "Bitte geben Sie einen Wert kleiner oder gleich {{max}} ein",
  
  // Error messages
  errorFetchingAddresses: "Fehler beim Abrufen von Adressen. Bitte versuchen Sie es erneut.",
  errorFetchingBuilding: "Fehler beim Abrufen von Gebäudedetails. Bitte versuchen Sie es erneut.",
  errorVerifyingCode: "Fehler bei der Überprüfung des Codes. Bitte versuchen Sie es erneut.",
  errorSubmittingValuation: "Fehler beim Übermitteln der Bewertung. Bitte versuchen Sie es erneut.",
  
  // Property types
  apartment: "Wohnung",
  house: "Haus",
  chalet: "Chalet",
  duplex: "Duplex",
  villa: "Villa",
  
  // Room formatting
  roomsFormat: "{{rooms}} Zimmer, {{bathrooms}} Badezimmer{{bathrooms_plural}}",
  bathrooms_plural_0: "",
  bathrooms_plural_1: "",
  bathrooms_plural_n: "",
  
  // Property conditions (matching API values)
  good_condition: "Guter Zustand",
  needs_renovation: "Renovierungsbedürftig",
  new_renovated: "Neu oder kürzlich renoviert",

};